import { observer } from 'mobx-react-lite';
import { Route, Switch } from 'react-router-dom';
import { BasePage, PageType } from 'src/components/BasePage';
import { SettingMenuItem } from 'src/pages/SettingsPage/SettingMenuItem';
import { SettingsRouterStore } from 'src/stores/SettingsRouterStore/SettingsRouterStore';
import { CssVariables } from 'src/styles/CssVariables';
import styled from 'styled-components';

export const SettingsPage = observer(() => {
    return (
        <StyledBasePage pageName="settings" type={PageType.FULL}>
            <SettingsAsidePanel />
            <StyledSettingsDetails>
                <Switch>
                    {SettingsRouterStore.routes.map((route) => (
                        <Route
                            key={route.key}
                            exact={route.exact !== false}
                            path={route.path}
                            component={route.Component}
                            render={route.render}
                        />
                    ))}
                </Switch>
            </StyledSettingsDetails>
        </StyledBasePage>
    );
});

const SettingsAsidePanel = observer(() => {
    return (
        <StyledSettingsAside>
            {SettingsRouterStore.menuItems.map((item) => (
                <SettingMenuItem key={item.key} item={item} />
            ))}
        </StyledSettingsAside>
    );
});

const StyledBasePage = styled(BasePage)`
    height: 100%;
    overflow: hidden;
    display: flex;
    position: relative;
    padding: 0;
`;

const StyledSettingsAside = styled.div`
    height: 100%;
    width: ${CssVariables.masterDetailsAsideWidth};
    display: flex;
    flex-direction: column;
    overflow: auto;
    padding: 0 1rem 0 1.2rem;
`;

const StyledSettingsDetails = styled.div`
    flex: 1;
    height: 100%;
    overflow-x: hidden;
    overflow-y: scroll;
`;
